<template>
  <div class="communication-container">
    <v-row>
      <v-col cols="12">
        <v-toolbar-title class="light-blue--text font-bold">Code Table Search</v-toolbar-title>
      </v-col>
    </v-row>
    <v-data-table
      :headers="headers"
      :items="listData"
      sort-by="transaction_date"
      sort-desc
      class="elevation-1"
      :footer-props="{
        showFirstLastPage: true,
        'items-per-page-options': [3, 5, 10, 20, 50, -1],
      }"
      :page.sync="page"
      :items-per-page="itemsPerPage"
      @page-count="pageCount = $event"
    >
      <template v-slot:top>
        <v-row>
          <v-col cols="12" md="1"> </v-col>
          <v-col cols="12" md="10"> </v-col>
          <v-col cols="12" md="1" class="text-right">
            <v-btn color="primary" block>
              Search
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="2">
            <v-select
              v-model="itemsPerPage"
              :items="[3, 5, 10, 20, 50, -1]"
              :menu-props="{ offsetY: true }"
              label="Rows per page"
              hide-details
              dense
            ></v-select>
          </v-col>
          <v-col cols="12" md="8">
            <v-pagination circle v-model="page" :length="pageCount" dense></v-pagination>
          </v-col>
          <v-col cols="12" md="2">
            <v-text-field
              v-model="search"
              append-icon="fa fa-search"
              label="Find by name"
              hide-details
              dense
            ></v-text-field>
          </v-col>
        </v-row>
        <v-dialog v-model="dialog" max-width="1500px">
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <codeTableDetail :item="editedItem"></codeTableDetail>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
              <v-btn color="blue darken-1" text @click="save">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template v-slot:item.status="{ item }">
        <font class="font-extrabold" :color="statusColor(item.status)">{{ item.status }}</font>
      </template>
      <template v-slot:item.source_data="{ item }">
        <font class="font-semibold cursor-pointer blue--text" @click="openDialog" :detail="item"
          >VIEW</font
        >
      </template>
      <template v-slot:item.target_data="{ item }">
        <font class="font-semibold cursor-pointer blue--text" @click="openDialog" :detail="item"
          >VIEW</font
        >
      </template>
      <template v-slot:item.manage="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)">
          fa fa-edit
        </v-icon>
        <v-icon small @click="deleteItem(item)">
          fa fa-trash
        </v-icon>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import codeTableDetail from '@/vue-caas/views/codetable/CodeTableList.vue';

export default {
  components: {
    codeTableDetail,
  },

  data: () => ({
    dialog: false,
    headers: [
      { text: 'Name', value: 'name' },
      { text: 'Last Update', value: 'last_update' },
      { text: 'Manage', value: 'manage' },
    ],
    listData: Array,
    search: '',
    editedIndex: -1,
    editedItem: {
      name: '',
      last_update: '',
      manage: '',
    },
    defaultItem: {
      name: '',
      last_update: '',
      manage: '',
    },
    statuses: ['SENT', 'ERROR'],
    searchKeys: ['Search Key 01', 'Search Key 02', 'Search Key 03', 'Search Key 04'],
    fromDateData: new Date().toISOString().substr(0, 10),
    fromDate: false,
    toDateData: new Date().toISOString().substr(0, 10),
    toDate: false,
    page: 1,
    pageCount: 0,
    itemsPerPage: 10,
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'New Item' : 'Edit Item';
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      this.$store.dispatch('getCodeTableList');
      this.listData = this.$store.getters.codeTableList;
    },

    editItem(item) {
      this.editedIndex = this.listData.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      const index = this.listData.indexOf(item);
      confirm('Are you sure you want to delete this item?') && this.listData.splice(index, 1);
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.listData[this.editedIndex], this.editedItem);
      } else {
        this.listData.push(this.editedItem);
      }
      this.close();
    },

    statusColor(status) {
      let color = '';

      if (status == 'SENT') {
        color = '#3f3';
      } else if (status == 'ERROR') {
        color = '#f33';
      }

      return color;
    },

    openDialog() {
      this.dialog = true;
    },
  },
};
</script>
